<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Salary Item 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row>
        <b-col lg="7">
          <b-form-group label-cols=1 label="Filter ">
              <b-row>
                <b-col class="pr-1" cols="4"><b-form-input v-model="filter.KdKompGaji" @keyup.13.native="refresh()" placeholder="Code"></b-form-input></b-col>
                <b-col class="pl-1" cols="8"><b-form-input v-model="filter.NmKompGaji" @keyup.13.native="refresh()" placeholder="Name"></b-form-input></b-col>
              </b-row>                      
          </b-form-group>
        </b-col>
        <b-col lg="3">
            <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @row-clicked="rowClicked"
        show-empty
      >
        <template #empty="scope">
          <h6 class="text-center">{{ scope.emptyText }}</h6>
        </template>
        <template #emptyfiltered="scope">
          <h6 class="text-center">{{ scope.emptyFilteredText }}</h6>
        </template>
        <template v-slot:cell(index)="data">
          {{ data.index +1}}
        </template>
        <template v-slot:cell(Upah)="data">
          <span v-if="data.item.Upah==0">Fixed</span>
        </template>
        <template v-slot:cell(TakeHome)="data">
          <span v-if="data.item.TakeHome==1">THP</span>
        </template>
        <template v-slot:cell(isPaket)="data">
          <span v-if="data.item.isPaket==1">Yes</span>
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
        <b-row class="mt-1">
          <b-col cols="4">
            <div>
              Showing {{(tblData.page - 1) * tblData.limit + 1}}
              to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
              of {{tblData.total}} entries
            </div>
          </b-col>
          <b-col cols="4" >
              <b-form-group label-cols=3 label="Limit per page"  style="margin-top:0 !important;">
              <b-form-select :options="[10, 15, 20, 25]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
              </b-form-group>
          </b-col>        
          <b-col cols="4">            
            <b-pagination
              align="right"
              :total-rows="tblData.total"
              :per-page="tblData.limit"
              v-model="tblData.page"
            ></b-pagination>
          </b-col>
        </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card >
            <div slot="header">Salary Item - Add/Edit Form </div>
                  <b-input-group>
                        <b-input-group-prepend><label>Item Code</label></b-input-group-prepend>
                      <b-form-input v-model="frmdata.KdKompGaji" :state="!$v.frmdata.KdKompGaji.$error"></b-form-input>
                  </b-input-group>
                  <b-input-group>
                        <b-input-group-prepend><label>Item Name</label></b-input-group-prepend>
                      <b-form-input v-model="frmdata.NmKompGaji" :state="!$v.frmdata.NmKompGaji.$error"></b-form-input>
                  </b-input-group>
                  <b-input-group >
                      <b-input-group-prepend><label>Item Type</label></b-input-group-prepend>
                      <b-form-select style=" width: 50%;"  v-model="frmdata.JenisKomp" :plain="true" :options="jenisKomps" :state="!$v.frmdata.JenisKomp.$error"></b-form-select>
                      <b-form-checkbox class="ml-3 mt-2 mr-2" v-model="frmdata.TakeHome" value="1" unchecked-value="0"><b>Take Home Pay Item</b></b-form-checkbox>
                  </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Fix(Lumpsump) Income</label></b-input-group-prepend>
                        <b-form-select  v-model="frmdata.Upah" :plain="true" :options="YesNo" ></b-form-select>
                        <b-input-group-prepend><span  class="pt-2 mr-2">&nbsp;&nbsp;&nbsp;&nbsp;Formula</span></b-input-group-prepend>
                      <b-form-input style=" width: 50%;" v-model="frmdata.rumus" :disabled="(frmdata.Upah == 0)" ></b-form-input>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>PPh 21 Form</label></b-input-group-prepend>
                        <b-form-select v-model="frmdata.IdFrm1721" :plain="true" :options="komponenPph" :state="!$v.frmdata.IdFrm1721.$error"></b-form-select>
                        <b-input-group-prepend><span  class="pt-2 mr-2">&nbsp;&nbsp;&nbsp;&nbsp;sifat</span></b-input-group-prepend>
                        <b-form-select  v-model="frmdata.SifatKomp" :plain="true" :options="sifatKomps" :state="!$v.frmdata.SifatKomp.$error"></b-form-select>
                    </b-input-group>
                  <b-input-group >
                      <b-input-group-prepend><label>Given/Mandatory</label></b-input-group-prepend>
                      <b-form-checkbox class="mt-2 mr-2" v-model="frmdata.isPaket" value="1" unchecked-value="0"><b> Mandatory (merupakan Hak Melekat pada setiap Karyawan)</b></b-form-checkbox>
                  </b-input-group>

                    <b-input-group >
                          <b-input-group-prepend><label>GL Account</label></b-input-group-prepend>
                        <b-form-input readonly v-model="frmdata.kodeaccInfo" :state="!$v.frmdata.kodeacc.$error"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="showLkuCoa('kodeacc')" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
             <b-button variant="secondary" class="mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>
        </b-card>

      </b-col>
    </b-row>
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true" :lazy="true">
            <lku-coa @click="onSelectLkuCoa" ></lku-coa>
        </b-modal>        
  </div>
</template>

<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 160px;
            }
        }
    }
</style>

<script>
import toastr from "mini-toastr";
import lkuCoa from "../lookup/lkuCoa";
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  components: {lkuCoa},
  mixins: [validationMixin],
  validations: {
    frmdata: {
        KdKompGaji: { required },
        NmKompGaji: { required },
        IdFrm1721: { required },
        JenisKomp: { required },
        SifatKomp: { required },
        TakeHome: { required },
        isPaket: { required },
        kodeacc: { required }
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      lkuCoaShow: false,
      showList:true,
      showForm:false,
      frmdata:{NmKompGaji: '', Upah:0, isPaket:0, kodeacc:'',JenisKomp:'', rumus:'', SifatKomp:'', TakeHome:'', IdFrm1721:'' },
      tblData: {
        tablename:'komponengaji',
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'TakeHome',
        sortDesc: true
      },
      filter:{},
     jenisKomps : ['Penerimaan', 'Potongan'],
     sifatKomps : ['Disetahunkan', 'tdk Disetahunkan'],
      YesNo :   [{ value: 0, text: 'YES' }, { value: 1, text: 'NO' }],
     komponenPph:[],
    };
  },
  computed: {
    tblFields(){
      const fields=[
          {
            key: "index",
            label: "No.",
            thStyle: "width:60px",
            thClass: "text-center",
          },
          {
            key: "KdKompGaji",
            label: "Item Code",
            sortable: true
          },
          {
            key: "NmKompGaji",
            label: "Item Name",
            sortable: true
          },
          {
            key: "JenisKomp",
            label: "Item Type",
            sortable: true
          },
          {
            key: "isPaket",
            label: "Mandatory",
            thStyle: "width:80px",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "TakeHome",
            label: "Take Home Pay",
            thStyle: "width:140px",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "Upah",
            label: "Lumpsump/Fix",
            thStyle: "width:100px",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "rumus",
            label: "Formula"
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          }          
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },

  },
  created: async function () {
        const [a] = await Promise.all([
          crud.list({
            tablename:'komponen1721',
            page: 1,
            limit: 1000,
            total: 0,
            sortBy: 'NmFrm1721',
            sortDesc: false
          }),
          ]);
        this.komponenPph = a.reduce((newArr,item) =>{
            newArr.push({ value: item.IdFrm1721, text: item.NmFrm1721});
            return newArr;
        },[]);
  },

  methods: {
    showLkuCoa(callerObj)
    {
      this.lkuCoaShow=true;
      this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
            this.frmdata[`${this.lkuCoaCaller}Info`] = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.frmdata[`${this.lkuCoaCaller}`] = _selected.kodeacc;
            this.frmdata[`${this.lkuCoaCaller}Name`] = _selected.namaacc;
        this.lkuCoaShow=false;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      let str='';
      if (this.filter.NmKompGaji){
        str = 'NmKompGaji=%' + encodeURIComponent(this.filter.NmKompGaji)+'%';
      }
      if (this.filter.KdKompGaji){
        str += str ? '&' : '';
        str = str + 'KdKompGaji=' + encodeURIComponent(this.filter.KdKompGaji)+'%';
      }
      this.tblData.customQuery=str;

      const list = await crud.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.frmdata.idlama = data.IdKompGaji;
     // this.frmdata.saleFeeInfo = (data.saleFeeCode || '').trim() + ' | ' + (data.saleFeeName || '').trim();
      // this.frmdata.saleDiscInfo = (data.saleDiscCode || '').trim() + ' | ' + (data.saleDiscName || '').trim();
      // this.frmdata.PrePaymDbAccInfo = data.PrePaymDbAcc;
      let _selected;
      try {
        if (data.kodeacc) {
          _selected = await crud.findcoa({kodeacc: data.kodeacc, tahun: 2019});
          this.frmdata.kodeaccInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        }
        if (data.kodeacc2) {
          _selected = await crud.findcoa({kodeacc: data.kodeacc2, tahun: 2019});
          this.frmdata.kodeacc2Info = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        }
        // if (data.PrePaymDbAcc) {
        //   _selected = await crud.findcoa({kodeacc: data.PrePaymDbAcc, tahun: 2019});
        //   this.frmdata.PrePaymDbAccInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        // }
      } catch (error) {
        if (error.message) {
            toastr.error(error.message);
        } else {
            toastr.error(JSON.stringify(error));
        }                      
      }      
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
    this.frmdata.Upah=this.frmdata.Upah || '0';                   
    this.frmdata.isPaket= this.frmdata.isPaket || '0';      
    this.frmdata.TakeHome= this.frmdata.TakeHome || '0';              

        if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "Error Info");
        } else {
            try {
              if (this.frmdata.idlama) {
                await crud.update(
                     {tablename:'komponengaji', 
                     key:this.frmdata.idlama, 
                     data:{KdKompGaji:this.frmdata.KdKompGaji, 
                        NmKompGaji:this.frmdata.NmKompGaji,                   
                        JenisKomp:this.frmdata.JenisKomp,                   
                        SifatKomp:this.frmdata.SifatKomp,                   
                        TakeHome:this.frmdata.TakeHome,                   
                        Upah:this.frmdata.Upah,                   
                        isPaket:this.frmdata.isPaket,                   
                        rumus:this.frmdata.rumus,                   
                        kodeacc:this.frmdata.kodeacc,                   
                        IdFrm1721:this.frmdata.IdFrm1721}
                      });
              } else {
                await crud.insert(
                  { tablename:'komponengaji',                      
                     data:{KdKompGaji:this.frmdata.KdKompGaji, 
                        NmKompGaji:this.frmdata.NmKompGaji,                   
                        JenisKomp:this.frmdata.JenisKomp,                   
                        SifatKomp:this.frmdata.SifatKomp,                   
                        TakeHome:this.frmdata.TakeHome,                   
                        Upah:this.frmdata.Upah,                   
                        isPaket:this.frmdata.isPaket,                   
                        rumus:this.frmdata.rumus,                   
                        kodeacc:this.frmdata.kodeacc,                   
                        IdFrm1721:this.frmdata.IdFrm1721}
                  });
              }
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({tablename:'komponengaji', key:this.model.IdKompGaji});
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
